import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/client/app/components/landing/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/client/app/components/landing/HookSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/client/app/components/LandingCityCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
